import React from 'react'
import { useListDeviceAutomationsQuery } from '../api/automationsApi'
import {
    Box,
    Grid,
    Text,
    Spinner,
    Flex,
    Accordion,
} from '@chakra-ui/react'
import NotFound from './NotFound'
import { useLocation } from 'react-router-dom'
import { Pagination } from '../../../app/components/Pagination'
import { DeviceCustomAccordionItem } from './DeviceCustomAccordionItem'

interface AutomationProps {
    deviceId: number
    groupId: number
    locationId: number
    searchInput: string
}

export default function DeviceAutomations({ deviceId, groupId, locationId, searchInput }: AutomationProps) {
    const location = useLocation()
    const pageNumber = Number(new URLSearchParams(location.search).get('page') || 1)
    const { data, isLoading } = useListDeviceAutomationsQuery({ device: deviceId, location: locationId, group: groupId, page: pageNumber, search: searchInput })
    const totalPages = data?.total_pages

    if (data?.results.length === 0) {
        return (
            <NotFound
                title="No automations"
                description="Currently there are no automations and smart control"
                header={false}
            />
        )
    }

    return (
        <Flex
            alignItems="flex-end"
            flexWrap="wrap-reverse"
            w="full"
            gap={6}
            bg="white"
            rounded="xl"
        >
            {(isLoading) ? (
                <Flex h="80vh" w="100%" justifyContent="space-around" align="center">
                    <Spinner size="xl" />
                </Flex>
            ) : (
                <Box w="100%" bg="white" borderRadius="md" boxShadow="md">
                    <Grid templateColumns="150px 0.7fr 0.7fr 1fr 1fr 1fr 1fr" gap={6} p={4}>
                        <Text fontSize="14px" fontWeight="700" color="text.light" textAlign="left">
                            Name
                        </Text>
                        <Text fontSize="14px" fontWeight="700" color="text.light">
                            Type
                        </Text>
                        <Text fontSize="14px" fontWeight="700" color="text.light">
                            Location
                        </Text>
                        <Text fontSize="14px" fontWeight="700" color="text.light">
                            Group
                        </Text>
                        <Text fontSize="14px" fontWeight="700" color="text.light">
                            Device
                        </Text>
                        <Text fontSize="14px" fontWeight="700" color="text.light">
                            Created at
                        </Text>
                        <Text fontSize="14px" fontWeight="700" color="text.light">
                            Actions
                        </Text>
                    </Grid>

                    <Accordion allowToggle outline="none" boxShadow="none">
                        {data?.results?.map((automation, index) => (
                            <DeviceCustomAccordionItem
                                index={index}
                                key={`${automation.id}-${index}`}
                                automation={automation}
                            />
                        ))}
                    </Accordion>

                    {totalPages > 1 ? (
                        <Pagination totalPages={totalPages} currentPage={pageNumber} />
                    ) : null}
                </Box>
            )}
        </Flex>
    )
}
